/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_IntroInputs */

const fr_psod_intro = /** @type {(inputs: Psod_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les informations relatives à l'erreur ont été remontées pour analyse.`)
};

const en_psod_intro = /** @type {(inputs: Psod_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information about the error has been sent for analysis.`)
};

/**
* | output |
* | --- |
* | "Information about the error has been sent for analysis." |
*
* @param {Psod_IntroInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_intro = /** @type {((inputs?: Psod_IntroInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_IntroInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_intro(inputs)
	return en_psod_intro(inputs)
});